import { createSelector } from 'reselect'

const selectedGroup = (state) => state.get('selectedGroup')

export const selectSelectedGroup = createSelector(
  [selectedGroup],
  (selectedGroup) => selectedGroup || localStorage.getItem('selectedGroup') || ''
)
